import { render } from "./Hexes.vue?vue&type=template&id=7d3413dd"
import script from "./Hexes.vue?vue&type=script&lang=js"
export * from "./Hexes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__